import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ApprovalsPage } from "@/features/approvals/ApprovalsPage";

const search = z.object({
  id: z.string().optional(),
  view: z.enum(["pending", "delegated", "approved", "rejected", "all"]).optional(),
});

export const Route = createFileRoute("/_app/approvals/")({
  validateSearch: search,
  component: () => <ApprovalsPage search={Route.useSearch()} />,
});
